import React, { FC, ReactNode } from 'react';
import { Typography } from '@mui/material';

interface IErrorText {
  children: ReactNode;
}

const ErrorText: FC<IErrorText> = ({ children }) => (
  <Typography
    fontSize={12}
    mt={1}
    color="#D32F2F"
  >
    {children}
  </Typography>
);

export { ErrorText };
